import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';

const invoicesPage = () =>
  import('@/modules/invoices/components/invoices-page.vue');
const invoicesLookup = () =>
  import('@/modules/invoices/components/invoices-lookup.vue');
const cutomerReport = () =>
  import('@/modules/invoices/components/rebate-customer-report.vue');
export default [
  {
    path: '',
    component: Layout,
    children: [
      {
        name: 'invoice',
        path: '/invoice',
        component: invoicesPage,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
      {
        name: 'invoices',
        path: '/invoices',
        component: invoicesLookup,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      },
      {
        name: 'rebate-customer-report',
        path: '/customer-report',
        component: cutomerReport,
        exact: true,
        meta: {
          auth: true,
          permission: Permissions.values.settingsEdit,
        },
      }
    ],
  },
];
